var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 40,
    viewBox: "0 0 43 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5554 0.717389C20.8667 -0.178171 22.1333 -0.178173 22.4446 0.717387L26.9143 13.5761C27.0516 13.9712 27.4203 14.2391 27.8385 14.2476L41.4491 14.525C42.397 14.5443 42.7884 15.7488 42.0329 16.3216L31.1847 24.5462C30.8514 24.7988 30.7105 25.2323 30.8316 25.6326L34.7738 38.6628C35.0483 39.5703 34.0237 40.3147 33.2454 39.7732L22.0712 31.9975C21.7279 31.7586 21.2721 31.7586 20.9288 31.9975L9.75456 39.7732C8.97632 40.3147 7.95167 39.5703 8.22623 38.6628L12.1684 25.6326C12.2895 25.2323 12.1486 24.7989 11.8153 24.5462L0.967148 16.3216C0.211616 15.7488 0.602995 14.5443 1.55092 14.525L15.1615 14.2476C15.5797 14.2391 15.9484 13.9712 16.0857 13.5762L20.5554 0.717389Z",
    fill: "inherit"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.ec2eb47b8341dc33c2696e772261109e.svg";
export { ForwardRef as ReactComponent };